import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import StatusBotIcon from '../../StatusBotIcon';
import { useAiCommandPalette } from '../context/AiCommandPaletteContext';

const AiOption = () => {
  const {
    inputValue,
    handleAiAsk,
    selectedIndex,
    isAskMode,
    currentMessage,
    completedMessages,
    searchResults,
    setSelectedIndex
  } = useAiCommandPalette();

  // Hide once in ask mode or when there are messages
  if (isAskMode || currentMessage.userQuery || completedMessages.length > 0) return null;
  
  if (!inputValue.trim()) return null;

  // AI option is selected when selectedIndex equals the length of search results
  const isSelected = selectedIndex === searchResults.length;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      onClick={() => {
        if (inputValue.trim()) {
          handleAiAsk();
        }
      }}
      onMouseMove={() => setSelectedIndex(searchResults.length)}
      className={`px-3 py-2.5 rounded-lg cursor-pointer group border transition-[border-color,box-shadow] duration-200 ${
        isSelected
          ? 'bg-gradient-to-r from-purple-50/60 to-violet-50/40 dark:from-purple-500/10 dark:to-violet-500/5 border-purple-300/50 dark:border-purple-400/20 shadow-sm'
          : 'bg-transparent border-transparent hover:bg-gradient-to-r hover:from-purple-50/40 hover:to-violet-50/30 dark:hover:from-purple-500/5 dark:hover:to-violet-500/[0.02] hover:border-purple-200/30 dark:hover:border-purple-400/10'
      }`}
    >
      <div className="flex items-start gap-3">
        <div className="pt-1">
          <StatusBotIcon className="h-5 w-5 text-teal-500" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-normal text-foreground transition-colors">
            Ask StatusBot "<span className="font-bold">{inputValue}</span>"
          </div>
          <div className="text-sm text-muted-foreground flex items-center gap-2 mt-1">
            Get AI-powered insights about your organization
          </div>
        </div>
        <div className="flex items-center self-center">
          <ChevronRight className={`h-4 w-4 text-muted-foreground transition-opacity ${
            isSelected ? 'opacity-100' : 'opacity-0'
          }`} />
        </div>
      </div>
    </motion.div>
  );
};

export default AiOption; 